import * as React from 'react';

function Footer () {
    return(
        <>
        <footer className="footer">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
            <div className="flex items-center justify-start space-x-3">
                <a>
                    <img src={`${process.env.PUBLIC_URL}/ABLE_LOGO_ONLY_MIDDLE.png`} alt="Logo" style={{ width: '100px', marginBottom: '10px', marginTop: '20px', marginLeft:'auto', marginRight:'auto'}} />
                </a>
                <div>
                    국립순천대학교 농업생물정보학 실험실
                </div>
                <div>
                    문의사항 email : hope9901@naver.com
                </div>
                <div>
                {/*<p>Distributed By: <a href="https://themewagon.com/" target="_blank" rel="noreferrer">ThemeWagon</a></p>*/}
                </div>
                {/*<a href="https://github.com/justboil/admin-one-tailwind" style={{height: '20px'}}>*/}
                {/*<img src="" alt={"log"}></img>*/}
                {/*</a>*/}
            </div>
        
            </div>
        </footer>
    </>
    )
}

export default Footer;